// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleCallToAction_container__ePXW0","ctaButton":"ArticleCallToAction_ctaButton__KT9Tc","text":"ArticleCallToAction_text__NNR6k"};